export default "__VITE_ASSET__zS2BPGl2__"